import{isWithinRange}from"../isWithinRange";// Makes sure that date is between min and max dates, returns a cloned min or max
export function moveToWithinRange(a,b,c){return isWithinRange(a,b,c)?a:new Date(b&&a<b?+b:+c)}